export default __webpack_public_path__ + "static/media/CSRealCase3-en.8649e77d.jpg";